import { PRODUCT_LECTURA, PRODUCT_READING } from 'root/lib/constants';
import STEP_TYPE from '../../data/StepTypes';
import {
  ACTIVITY_STATUS,
  GRADES,
  SEASON_PART,
  WORKSHOP_BENCHMARK_IDS,
  WORKSHOP_BOOK_TRACK_IDS,
} from '../../data/constants';
import { defaultSeason3Curioso } from '../../data/CuriosoConfigOptions';
import gameIds from '../../data/GameIds';

const WorkshopQuests = require('../../data/WorkshopQuests.json');

const workshopState = {
  benchmark: WORKSHOP_BENCHMARK_IDS.NORMAL,
  bookTrack: WORKSHOP_BOOK_TRACK_IDS.NORMAL,
  workshopStep: 0,
  shouldStartNewChallengeQuest: false,
  currentQuestId: 301, // quest user currently works with
  grade: GRADES.GRADE_4,
  seasonPart: SEASON_PART.A,
  placement: undefined,
  isVocabAppAvailable: true, // disabling/enabling Vocab temporary
  lastQuestFinishedBeforeEndOfQuests: undefined, // last quest user played before End Of Quests popup appeared
  lastTimeQuestWasSwitched: undefined, //
  questSessionId: '',
  gameFailures: {},
  workshop: {
    ...WorkshopQuests.workshop,
  },
  rewards: {
    TFE: [], // list of reward items
    eReader: null, // reward item
  },
  myCollection: {
    curtains: ['DefaultCurtains'], // all available for user
    book: ['orange', 'green', 'blue'], // all available for user
    desk: [], // all available for user
    music: ['off', 'ambient'], // all available for user
    color: ['Lights'], // all available for user
    selectedCurtains: 'DefaultCurtains', // currently selected
    selectedBook: '', // currently selected
    selectedDesk: '', // currently selected
    selectedMusic: 'ambient', // currently selected
    selectedColor: 'Lights', // currently selected
  },
  vocabResults: {},
  isQuestInDemoMode: false,
  isVocabAppAvailableInDemoMode: true,
  selectedCurioso: defaultSeason3Curioso,
  shouldShowReplacementModal: false, // flipped when user's placement is changed
  hasSeenReplacementModal: false, // flag to mark that user has seen replacement modal
  areAllQuestsAndChallengesComplete: {
    [PRODUCT_READING]: false,
    [PRODUCT_LECTURA]: false,
  },
};

export const workshopStateForDemo = {
  benchmark: WORKSHOP_BENCHMARK_IDS.NORMAL,
  bookTrack: WORKSHOP_BOOK_TRACK_IDS.NORMAL,
  workshopStep: 0,
  currentQuestId: 301, // quest user currently works with
  grade: GRADES.GRADE_4,
  seasonPart: SEASON_PART.A,
  isVocabAppAvailable: true, // disabling/enabling Vocab temporary
  lastQuestFinishedBeforeEndOfQuests: undefined, // last quest user played before End Of Quests popup appeared
  lastTimeQuestWasSwitched: undefined, //
  questSessionId: '',
  gameFailures: {},
  workshop: {
    quest301: {
      nextQuestId: 0,
      previousQuestId: 301,
      updated: '',
      startDate: '',
      questSessionId: '',
      eReader: {
        useStaticAsset: false,
        status: ACTIVITY_STATUS.IDLE,
        bookId: 'ereader.created_equal',
        bookName: 'Created Equal',
        chapter: 'Chapter3',
      },
      vocab: {
        useStaticAsset: false,
        status: ACTIVITY_STATUS.IDLE,
        sessions: [
          { id: '301.1', progress: '' },
          { id: '301.2', progress: '' },
          { id: '301.3', progress: '' },
        ],
      },
      TFE: {
        useStaticAsset: false,
        status: ACTIVITY_STATUS.IDLE,
        episode: {
          id: 'episode03',
          progress: '',
          parts: [
            {
              id: 'episode03_part1_r',
              progress: '',
            },
            {
              id: 'episode03_part2_r',
              progress: '',
            },
            {
              id: 'episode03_part3_r',
              progress: '',
            },
          ],
        },
      },
      battery: {
        useStaticAsset: false,
        status: ACTIVITY_STATUS.IDLE,
      },
      games: [
        {
          type: STEP_TYPE.GAME,
          game: gameIds.DIRECTORS_CUT,
          levels: [0],
          levelsMastered: [],
          friendlyName: '',
          skillId: -1,
        },
        {
          type: STEP_TYPE.GAME,
          game: gameIds.YEARBOOK,
          levels: [0],
          levelsMastered: [],
          friendlyName: '',
          skillId: -2,
        },
        {
          type: STEP_TYPE.GAME,
          game: gameIds.WORD_SLIDE,
          levels: [10, 11],
          levelsMastered: [],
          friendlyName: '',
          skillId: -3,
        },
      ],
      transmissionSequenceId: null,
      transmissionText: null,
    },
    /* Used for End Of Quests Experience */
    challengeQuest: {
      ...WorkshopQuests.workshop.challengeQuest,
    },
  },
  rewards: {
    TFE: [
      'Ship Carving',
    ], // list of reward items
    eReader: null, // reward item
  },
  myCollection: {
    curtains: ['DefaultCurtains', 'RewardChoiceCurtains7', 'RewardChoiceCurtains12', 'RewardChoiceCurtains14'], // all available for user
    book: ['blue', 'RewardChoiceBook4', 'RewardChoiceBook5', 'RewardChoiceBook11', 'RewardChoiceBook15'], // all available for user
    desk: ['RewardCr1', 'RewardCr3', 'RewardCr5', 'RewardCr6', 'RewardCr8', 'RewardCr11', 'RewardCr16'], // all available for user
    music: ['off', 'ambient', 'RewardChoiceMusic2', 'RewardChoiceMusic6', 'RewardChoiceMusic9', 'RewardChoiceMusic13'], // all available for user
    color: ['Lights', 'RewardChoiceLight3', 'RewardChoiceLight8', 'RewardChoiceLight10', 'RewardChoiceLight16'], // all available for user
    selectedCurtains: 'DefaultCurtains', // currently selected
    selectedBook: 'blue', // currently selected
    selectedDesk: 'RewardCr1', // currently selected
    selectedMusic: 'ambient', // currently selected
    selectedColor: 'Lights', // currently selected
  },
  vocabResults: {},
  isQuestInDemoMode: true,
  isVocabAppAvailableInDemoMode: true,
  selectedCurioso: defaultSeason3Curioso,
  areAllQuestsAndChallengesComplete: {
    [PRODUCT_READING]: false,
    [PRODUCT_LECTURA]: false,
  },
};

export const workshopStateForLecturaDemo = {
  benchmark: WORKSHOP_BENCHMARK_IDS.NORMAL,
  bookTrack: WORKSHOP_BOOK_TRACK_IDS.NORMAL,
  workshopStep: 0,
  currentQuestId: 301, // quest user currently works with
  grade: GRADES.GRADE_4,
  seasonPart: SEASON_PART.A,
  isVocabAppAvailable: true, // disabling/enabling Vocab temporary
  lastQuestFinishedBeforeEndOfQuests: undefined, // last quest user played before End Of Quests popup appeared
  lastTimeQuestWasSwitched: undefined, //
  questSessionId: '',
  gameFailures: {},
  workshop: {
    quest301: {
      nextQuestId: 0,
      previousQuestId: 301,
      updated: '',
      startDate: '',
      questSessionId: '',
      eReader: {
        useStaticAsset: false,
        status: ACTIVITY_STATUS.IDLE,
        bookId: 'ereader.created_equal',
        bookName: 'Created Equal',
        chapter: 'Chapter3',
      },
      vocab: {
        useStaticAsset: false,
        status: ACTIVITY_STATUS.IDLE,
        sessions: [
          { id: '301.1', progress: '' },
          { id: '301.2', progress: '' },
          { id: '301.3', progress: '' },
        ],
      },
      TFE: {
        useStaticAsset: false,
        status: ACTIVITY_STATUS.IDLE,
        episode: {
          id: 'episode03',
          progress: '',
          parts: [
            {
              id: 'episode03_part1_r',
              progress: '',
            },
            {
              id: 'episode03_part2_r',
              progress: '',
            },
            {
              id: 'episode03_part3_r',
              progress: '',
            },
          ],
        },
      },
      battery: {
        useStaticAsset: false,
        status: ACTIVITY_STATUS.IDLE,
      },
      games: [
        {
          type: STEP_TYPE.GAME,
          game: gameIds.GEM_NYE_FRIENDS,
          levels: [23, 24],
          levelsMastered: [],
          friendlyName: '',
          skillId: -1,
          product: PRODUCT_LECTURA,
        },
        {
          type: STEP_TYPE.GAME,
          game: gameIds.HANGRY_GOBLINS,
          levels: [2, 3, 4],
          levelsMastered: [],
          friendlyName: '',
          skillId: -2,
          product: PRODUCT_LECTURA,
        },
        {
          type: STEP_TYPE.GAME,
          game: gameIds.SILABALON,
          levels: [17],
          levelsMastered: [],
          friendlyName: '',
          skillId: -3,
          product: PRODUCT_LECTURA,
        },
      ],
      transmissionSequenceId: null,
      transmissionText: null,
    },
    /* Used for End Of Quests Experience only */
    challengeQuest: {
      ...WorkshopQuests.workshop.challengeQuest,
    },
  },
  areAllQuestsAndChallengesComplete: {
    [PRODUCT_READING]: false,
    [PRODUCT_LECTURA]: false,
  },
  rewards: {
    TFE: [
      'Ship Carving',
    ], // list of reward items
    eReader: null, // reward item
  },
  myCollection: {
    curtains: ['DefaultCurtains', 'RewardChoiceCurtains7', 'RewardChoiceCurtains12', 'RewardChoiceCurtains14'], // all available for user
    book: ['blue', 'RewardChoiceBook4', 'RewardChoiceBook5', 'RewardChoiceBook11', 'RewardChoiceBook15'], // all available for user
    desk: ['RewardCr1', 'RewardCr3', 'RewardCr5', 'RewardCr6', 'RewardCr8',
      'RewardCr11', 'RewardCr16'], // all available for user
    music: ['off', 'ambient', 'RewardChoiceMusic2', 'RewardChoiceMusic6', 'RewardChoiceMusic9', 'RewardChoiceMusic13'], // all available for user
    color: ['Lights', 'RewardChoiceLight3', 'RewardChoiceLight8', 'RewardChoiceLight10', 'RewardChoiceLight16'], // all available for user
    selectedCurtains: 'DefaultCurtains', // currently selected
    selectedBook: 'blue', // currently selected
    selectedDesk: 'RewardCr1', // currently selected
    selectedMusic: 'ambient', // currently selected
    selectedColor: 'Lights', // currently selected
  },
  vocabResults: {},
  isQuestInDemoMode: true,
  isVocabAppAvailableInDemoMode: true,
  selectedCurioso: defaultSeason3Curioso,
  newQuestReleased: undefined, // change to undefined when no new quests released
};

export default workshopState;
